import { createContext } from 'react';
import { DateRange } from 'shared/types/date-range';
import { ID } from 'shared/types/id';

export type GoalProgressDateRangeContextValue = {
  ranges: Record<ID, DateRange>;
  setRange: (goalId: ID, range: DateRange) => void;
};

export const GoalProgressDateRangeContext = createContext<
  GoalProgressDateRangeContextValue | undefined
>(undefined);
